import { api } from "../helpers/apiHelperV3";
import { urls } from "./urls";
//

const API_DEPOSIT = urls.cashier.API_DEPOSIT("skrill");
const API_WITHDRAW = urls.cashier.API_WITHDRAW("skrill");

/**
 * Deposit funds to Skrill account
 */
export const depositFunds = (amount: string, emailId: string): any => {
  const url = API_DEPOSIT;
  const data = {
    amount: amount,
    emailId: emailId,
  };
  return api.post(url, data);
};

/**
 * Withdraw funds from Skrill account
 */
export const withdrawFunds = (amount: string, emailId: string): any => {
  const url = API_WITHDRAW;
  const data = {
    amount: amount,
    emailId: emailId,
  };
  return api.post(url, data);
};
